import {Injectable} from "@angular/core";
import {Actions, createEffect, ofType} from "@ngrx/effects";
import * as jobAction from '../actions/job.action';
import {LOAD_JOB, LoadJob} from '../actions/job.action';
import {DbResponse} from "../../shared/interceptors/db-response";
import {filter, map, mergeMap} from 'rxjs/operators';
import {BackupService} from "../../websites/website/backup/backup.service";
import {Config} from "../../config/config";
import {ActivityAction, ActivityStatus} from "../../activities/activity";
import * as ongoingActivityActions from "../actions/ongoing-activities.action";
import {FinishOngoingActivity} from "../actions";
import * as websiteProductActions from "../actions/website-product.action";
import {LoadWebsiteProductsSuccess} from "../actions/website-product.action";
import {Utils} from "../../shared/utils/utils";

@Injectable()
export class JobEffect {

  websiteProductsLoaded$ = createEffect(() => this._actions$.pipe(
    ofType(websiteProductActions.LOAD_WEBSITE_PRODUCTS_SUCCESS),
    filter((action: any): boolean => {
      const backupPluginData: any = action.payload.pluginEntities[Config.backupPluginSlug];

      if (!backupPluginData || !!action.payload.isChildWebsite) {
        return false;
      }

      const isInstalled: boolean = Utils.isTruthy(backupPluginData.installed) && Utils.isTruthy(backupPluginData.is_paid);
      const isActive: boolean = Utils.isTruthy(backupPluginData.active);
      return isInstalled && isActive;
    }),
    map((action: LoadWebsiteProductsSuccess) => {
      return new jobAction.LoadJob(action.payload.websiteId);
    })
  ));

  finishOngoingActivity$ = createEffect(() => this._actions$.pipe(
    ofType(ongoingActivityActions.FINISH_ONGOING_ACTIVITY),
    filter((action: FinishOngoingActivity): boolean =>
      (<string[]>[ActivityAction.INSTALL_ACTIVATE, ActivityAction.ACTIVATE]).includes(action.payload.entity.action)
      && action.payload.entity.status === ActivityStatus.DONE
    ),
    filter((action: FinishOngoingActivity): boolean =>
      action.payload.entity.meta && action.payload.entity.meta.product_data.slug === Config.backupPluginSlug
    ),
    map((action: FinishOngoingActivity) => {
      return new jobAction.LoadJob(action.payload.websiteId);
    })
  ));

  updateWebsiteProductStateActivity$ = createEffect(() => this._actions$.pipe(
    ofType(ongoingActivityActions.FINISH_ONGOING_ACTIVITY),
    filter((action: FinishOngoingActivity): boolean => (<string[]>[
      ActivityAction.INSTALL,
      ActivityAction.INSTALL_ACTIVATE,
    ]).includes(action.payload.entity.action) && action.payload.entity.status === ActivityStatus.DONE),
    filter((action: FinishOngoingActivity): boolean =>
      action.payload.entity.meta && action.payload.entity.meta.product_data.slug === Config.backupPluginSlug
    ),
    map((action: FinishOngoingActivity) => {
      return new jobAction.LoadJob(action.payload.websiteId);
    })
  ));

  loadJob$ = createEffect(() => this._actions$.pipe(
    ofType(LOAD_JOB),
    mergeMap((action: LoadJob) => {
      return this._backupService.getDefaultJobs(action.payload)
        .pipe(
          filter((response: DbResponse) => !!response),
          map((response: DbResponse) => {
            if (response.success) {
              return new jobAction.LoadJobSuccess({
                websiteId: action.payload,
                entities: response.data
              });
            }
            return new jobAction.LoadJobFail(response.message);
          })
        );
    })
  ));

  constructor(
    private _actions$: Actions,
    private _backupService: BackupService
  ) {
  }
}
